import React, { Component, forwardRef } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';
import classes from './Menu.scss';
import config from 'cityads-v3/config';
import withHooks from 'cityads-v3/decorators/withHooks'
import { useTheme } from '@mui/material'

import Collapse from '@mui/material/Collapse'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import Tooltip from 'cityads-v3/components/Tooltip/Tooltip';

import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined'
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import SettingsApplicationsOutlinedIcon from '@mui/icons-material/SettingsApplicationsOutlined'
import LoyaltyOutlinedIcon from '@mui/icons-material/LoyaltyOutlined'
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined'
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined'
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined'
import MailOutlinedIcon from '@mui/icons-material/MailOutlined'
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined'
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';

import ModerationIcon from './img/Moderation';

import FiranoIcon from 'cityads-v3/components/Icons/FiranoIcon';
import AdvertisingMarking from 'cityads-v3/components/Icons/AdvertisingMarking';

import {
  toggleMenu,
} from 'cityads-v3/actions/menu';

const kToIcon = {
  cityads_dashboard: <DashboardOutlinedIcon />,
  cityads_webmaster_office: <HomeOutlinedIcon />,
  stat: <BarChartOutlinedIcon />,
  v3_offers_section: <StarBorderOutlinedIcon />,
  cityads_tools: <SettingsOutlinedIcon />,
  cityads_ads: <LoyaltyOutlinedIcon />,
  cityads_manager_tools: <SettingsOutlinedIcon />,
  manager_tools: <SettingsOutlinedIcon />,
  manager_tools2: <SettingsApplicationsOutlinedIcon />,
  cityads_users: <PeopleOutlineOutlinedIcon />,
  manager_users: <PeopleOutlineOutlinedIcon />,
  manager_finances: <AttachMoneyOutlinedIcon />,
  manager_payments: <AccountBalanceWalletOutlinedIcon />,
  cityads_manager_offers: <StarBorderOutlinedIcon />,
  v3_finance_tool: <FiranoIcon />,
  mailing_new_mailing: <MailOutlinedIcon />,
  v3_moderation: <ModerationIcon />,
  v3_advertising_marking: <AdvertisingMarking />,
}

@withHooks(props => {
  const theme = useTheme()
  return {
    isDark: theme.palette.mode === 'dark',
    ...props
  }
})
@withRouter
@connect(state => ({
  docked: state.menu.docked,
  isMobile: state.app.isMobile,
}))
export class MenuItem extends Component {

  static defaultProps = {
    depth: 0
  };

  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      openDocked: this.getInitialOpenState(props),
      openUndocked: false,
    };
  }

  getInitialOpenState(props) {
    const { c, location } = this.props;

    if (!c || !c.length) { return false; }

    for (let child of c) {
      if (child && child.app_id === config.AUTH_APP_ID && child.p === location.pathname) {
        return true;
      }
    }

    return false;
  }

  get hasSub() {
    return Boolean(this.props.c && this.props.c.length);
  }

  onClick = (evt) => {
    const { isMobile, dispatch, clickFromParent, docked } = this.props;

    if (this.hasSub) {
      evt.preventDefault();

      if (docked || isMobile) {
        this.setState({
          openDocked: !this.state.openDocked,
        });
      } else {
        this.setState({
          anchorEl: evt.currentTarget,
          openUndocked: !this.state.openUndocked,
        });
      }
    } else if(isMobile) {
      dispatch(toggleMenu(false, false));
    } else {
      clickFromParent && clickFromParent();
    }
  }

  onClose = () => {
    this.setState({
      openUndocked: false,
    });
  }

  getItemLink({ app_id, d, p, h }) {
    let url = '';

    if (d && app_id !== config.AUTH_APP_ID) {
      url = '//' + d;
    }

    if (p) {
      url += p;
    }

    if (h) {
      url += h;
    }

    return url;
  }

  isItemSelected({ c, app_id, p }) {
    if (c && c.length) {
      return c.some(child => this.isItemSelected(child));
    }

    if (app_id !== config.AUTH_APP_ID) {
      return false;
    }

    const { location } = this.props;

    return p.split('?')[0] === location.pathname;
  }

  render() {
    const { app_id, c, d, h, n, p, k, t, docked, depth, dispatch, location, isMobile, popped, clickFromParent, forwardedRef, isDark } = this.props;
    const isPrimaryLink = app_id === config.AUTH_APP_ID;
    const url = this.getItemLink({ app_id, d, p, h });
    const isSelected = this.isItemSelected({ c, app_id, p });

    const component = c ? undefined : isPrimaryLink ? Link : 'a';

    return (
      <React.Fragment key={n}>
        <Tooltip
          isLight
          enabled={!docked}
          enterDelay={config.TOOLTIP_DELAY}
          title={t}
          disableFocusListener={true}
          placement="right"
        >
          <ListItem
            dense={depth > 1}
            ref={forwardedRef}
            sx={{ p: 0 }}
          >
            <ListItemButton
              component={component}
              to={isPrimaryLink ? url : undefined}
              href={(!isPrimaryLink && !c) ? url : undefined}
              onClick={this.onClick}
              selected={isSelected}
            >
              {!depth && (
                <ListItemIcon
                  sx={{
                    margin: !docked && !isMobile ? 'auto' : '0',
                    minWidth: 'initial',
                    marginRight: docked || isMobile ? '0.75em' : 'auto',
                  }}
                >
                  {kToIcon[k]}
                </ListItemIcon>
              )}

              {(docked || isMobile) && (
                <ListItemText
                  primary={t}
                  classes={{
                    root: classNames({
                      [classes.itemTextTop]: depth < 1,
                      [classes.itemTextDepth1]: !popped && docked && depth === 1,
                      [classes.itemTextSub]: popped && depth > 1,
                      [classes.itemTextSub_docked]: docked && !popped && depth > 1,
                    }),
                    primary: classNames({
                      [classes.itemTextPrimaryTop]: depth === 0,
                      [classes.isDark]: isDark
                    }),
                  }}
                />
              )}

              {(docked || isMobile) && this.hasSub && (
                this.state.openDocked ?
                  <ExpandLessOutlinedIcon />
                  :
                  <ExpandMoreOutlinedIcon />
              )}
            </ListItemButton>
          </ListItem>
        </Tooltip>

        {this.hasSub && (
          (docked || isMobile) ?
            <Collapse in={this.state.openDocked} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {c.map(nestedItem => (
                  <MenuItem
                    key={nestedItem.n}
                    depth={depth + 1}
                    docked={docked}
                    popped={popped}
                    isMobile={isMobile}
                    dispatch={dispatch}
                    location={location}
                    {...nestedItem}
                  />
                ))}
              </List>
            </Collapse>
            :
            <Menu
              anchorEl={this.state.anchorEl}
              anchorOrigin={{horizontal: 'right', vertical: 'top'}}
              transformOrigin={{horizontal: 'left', vertical: 'top'}}
              open={this.state.openUndocked}
              onClose={this.onClose}
            >
              {c.map(nestedItem => (
                <MenuItem
                  {...nestedItem}
                  key={nestedItem.n}
                  clickFromParent={clickFromParent || this.onClose}
                  docked={true}
                  popped={true}
                  location={location}
                  depth={depth+1}
                />
              ))}
            </Menu>
        )}

      </React.Fragment>
    );
  }
}

export default forwardRef((props, ref) => <MenuItem {...props} forwardedRef={ref} />);
